import * as _ from 'lodash';
import * as React from 'react';
import { Button, Col, Input, Row } from 'reactstrap';
import { Svg } from 'src/components/shared/Svg';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { IProposition, IUser } from 'src/model';
import { createEvaluation } from 'src/services';
import { Notation } from './Notation';

const EvaluationPropositionEditionConfig = [
  'Connaissances fonctionnelles',
  'Connaissances techniques',
  'Disponibilités',
  'Qualité des livrables',
  'Rapidité',
  'Réactivité',
  'Respect des délais',
];

interface IEvaluationPropositionEditionProps {
  consultant: IUser;
  proposition: IProposition;
}

const EvaluationPropositionEdition: React.SFC<
  IEvaluationPropositionEditionProps & IGlobalContextProps
> = ({ consultant, context, proposition }) => {
  const { user } = context;
  const isConsultant = user && user.type === 'consultant';
  const isDisabled =
    isConsultant ||
    (proposition.evaluation && !!proposition.evaluation.evaluationDate);
  const [evaluation, setEvaluation] = React.useState(proposition.evaluation);
  const pictureUrl =
    consultant &&
    consultant.profile.picture &&
    consultant.profile.picture.pictureUrl;

  const handleClick = (label: string, notation: 1 | 2 | 3 | 4 | 5) => {
    if (!isDisabled) {
      const index = _.findIndex(evaluation.notationList, { label });
      const notationList = evaluation.notationList;
      index === -1
        ? evaluation.notationList.push({ label, notation })
        : (evaluation.notationList[index] = { label, notation });
      setEvaluation({
        ...evaluation,
        notationList,
      });
    }
  };

  const handleChange = (e: React.ChangeEvent<Element>) => {
    setEvaluation({
      ...evaluation,
      comments: (e.target as any).value,
    });
  };

  const saveEvaluation = async () => {
    const { project, updateProject } = context;
    const newProposition = await createEvaluation(proposition._id, evaluation);
    if (project && newProposition) {
      updateProject({
        ...project,
        proposition: newProposition,
      });
    }
  };

  return (
    <>
      <Row>
        <Col className='d-flex flex-column align-items-center' md='2'>
          {pictureUrl ? (
            <img
              className='d-block rounded-circle'
              src={pictureUrl}
              style={{ height: '80px', width: '80px' }}
            />
          ) : (
            <div
              className='d-flex justify-content-around rounded-circle bg-primary'
              style={{ height: '80px', width: '80px' }}
            >
              <Svg width={36} fill='white' src='user' />
            </div>
          )}
          <div className='mt-3'>
            {consultant &&
              `${(consultant as IUser).firstname} ${
                (consultant as IUser).lastname[0]
              }.`}
          </div>
        </Col>
        <Col md='10'>
          <Row>
            {EvaluationPropositionEditionConfig.map(
              (label: string, key: number) => (
                <Notation
                  key={key}
                  notationList={evaluation.notationList}
                  label={label}
                  handleClick={handleClick}
                />
              )
            )}
          </Row>
          <Row className='w-100 pb-5'>
            <Col md='12'>
              <Input
                type='textarea'
                disabled={isDisabled}
                placeholder='Votre commentaire'
                value={evaluation.comments}
                onChange={handleChange}
                style={{ minHeight: '80px' }}
              />
            </Col>
          </Row>
          {isConsultant ? null : (
            <Row className='pb-5'>
              <Col>
                {proposition.evaluation &&
                proposition.evaluation.evaluationDate ? (
                  <span className='text-success' style={{ fontSize: '20px' }}>
                    {`Merci ! Votre évaluation a bien été envoyée le ${new Date(
                      proposition.evaluation.evaluationDate
                    ).toLocaleDateString()}`}
                  </span>
                ) : (
                  <Button
                    className='text-uppercase text-white bg-success border-0'
                    onClick={saveEvaluation}
                  >
                    Envoyer
                  </Button>
                )}
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </>
  );
};

export const EvaluationPropositionEditionWithGlobalContext = withGlobalContext(
  EvaluationPropositionEdition
);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectEvaluation/EvaluationProposition/EvaluationPropositionEdition.tsx